import { ColumnSort, TableFilters } from '../../../shared/table/types';
import { ClientDocumentGroup, DocumentNameDB } from '../../documents/store/types';
import { EntityType } from '../../entity/store/types';

export enum AccessGroupActionTypes {
    FETCH_ALL_ACCESS_GROUPS_STARTED = 'FETCH_ALL_ACCESS_GROUPS_STARTED',
    FETCH_ALL_ACCESS_GROUPS_SUCCESSFUL = 'FETCH_ALL_ACCESS_GROUPS_SUCCESSFUL',
    FETCH_ALL_ACCESS_GROUPS_FAILED = 'FETCH_ALL_ACCESS_GROUPS_FAILED',
    TOGGLE_ACCESS_GROUP_MODAL = 'TOGGLE_ACCESS_GROUP_MODAL',
    SELECT_ACCESS_GROUP_SECTION = 'SELECT_ACCESS_GROUP_SECTION',
    UPDATE_ACCESS_GROUP = 'UPDATE_ACCESS_GROUP',
    FETCH_ALL_ENTITIES_FOR_ACCESS_GROUPS_STARTED = 'FETCH_ALL_ENTITIES_FOR_ACCESS_GROUPS_STARTED',
    FETCH_ALL_ENTITIES_FOR_ACCESS_GROUPS_SUCCESSFUL = 'FETCH_ALL_ENTITIES_FOR_ACCESS_GROUPS_SUCCESSFUL',
    FETCH_ALL_ENTITIES_FOR_ACCESS_GROUPS_FAILED = 'FETCH_ALL_ENTITIES_FOR_ACCESS_GROUPS_FAILED',
    TOGGLE_ACCESS_GROUP_COLUMN_SORT = 'TOGGLE_ACCESS_GROUP_COLUMN_SORT',
    SET_ACCESS_GROUP_FILTERS = 'SET_ACCESS_GROUP_FILTERS',
    CLEAR_ACCESS_GROUP_FILTERS = 'CLEAR_ACCESS_GROUP_FILTERS',
    SET_GROUP_NAME_IS_UNIQUE = 'SET_GROUP_NAME_IS_UNIQUE',
    SET_ACCESS_GROUP_UPDATED = 'SET_ACCESS_GROUP_UPDATED',
    SAVE_ACCESS_GROUP_STARTED = 'SAVE_ACCESS_GROUP_STARTED',
    SAVE_ACCESS_GROUP_SUCCESSFUL = 'SAVE_ACCESS_GROUP_SUCCESSFUL',
    SAVE_ACCESS_GROUP_FAILED = 'SAVE_ACCESS_GROUP_FAILED',
    FETCH_DOCUMENT_NAMES_FOR_ACCESS_GROUPS_STARTED = 'FETCH_DOCUMENT_NAMES_FOR_ACCESS_GROUPS_STARTED',
    FETCH_DOCUMENT_NAMES_FOR_ACCESS_GROUPS_SUCCESSFUL = 'FETCH_DOCUMENT_NAMES_FOR_ACCESS_GROUPS_SUCCESSFUL',
    FETCH_DOCUMENT_NAMES_FOR_ACCESS_GROUPS_FAILED = 'FETCH_DOCUMENT_NAMES_FOR_ACCESS_GROUPS_FAILED',
    FETCH_DOCUMENT_GROUPS_FOR_ACCESS_GROUPS_STARTED = 'FETCH_DOCUMENT_GROUPS_FOR_ACCESS_GROUPS_STARTED',
    FETCH_DOCUMENT_GROUPS_FOR_ACCESS_GROUPS_SUCCESSFUL = 'FETCH_DOCUMENT_GROUPS_FOR_ACCESS_GROUPS_SUCCESSFUL',
    FETCH_DOCUMENT_GROUPS_FOR_ACCESS_GROUPS_FAILED = 'FETCH_DOCUMENT_GROUPS_FOR_ACCESS_GROUPS_FAILED',
    TOGGLE_DELETE_ACCESS_GROUP_CONFIRMATION_MODAL = 'TOGGLE_DELETE_ACCESS_GROUP_CONFIRMATION_MODAL',
    DELETE_ACCESS_GROUP_STARTED = 'DELETE_ACCESS_GROUP_STARTED',
    DELETE_ACCESS_GROUP_SUCCESSFUL = 'DELETE_ACCESS_GROUP_SUCCESSFUL',
    DELETE_ACCESS_GROUP_FAILED = 'DELETE_ACCESS_GROUP_FAILED'
}

export enum AccessGroupSection {
    GENERAL = 'General',
    USERS = 'Users',
    ENTITIES = 'Entities',
    DOCUMENTS = 'Documents'
}

export enum AccessGroupTableName {
    USER = 'User',
    ENTITY = 'Entity',
    DOCUMENT = 'Document',
    DOCUMENT_GROUP = 'DocumentGroup',
    ROLE = 'Role'
}

export interface AccessGroup {
    accessGroupId?: number;
    accessGroupName: string;
    description: string | null;
    entityIds: number[];
    userIds: number[];
    documentNameIds: number[];
    roleIds: number[]
}

export interface AccessGroupEntity {
    entityId: number;
    name: string;
    type: EntityType;
    myCompany: number;
    canBeAgent: number;
    onWatchlist: number;
    groupEntities: number[];
}

export interface AccessGroupState {
    allAccessGroups: AccessGroup[];
    fetchingAccessGroups: boolean;
    currentAccessGroup: AccessGroup;
    savedAccessGroup: AccessGroup;
    accessGroupModalOpen: boolean;
    selectedAccessGroupSection: AccessGroupSection;
    entitiesForAccessGroups: AccessGroupEntity[];
    accessGroupUserColumnSort?: ColumnSort;
    accessGroupUserFilters: TableFilters;
    accessGroupEntityColumnSort?: ColumnSort;
    accessGroupEntityFilters: TableFilters;
    accessGroupDocumentColumnSort?: ColumnSort;
    accessGroupDocumentFilters: TableFilters;
    accessGroupDocumentGroupColumnSort?: ColumnSort;
    accessGroupDocumentGroupFilters: TableFilters;
    accessGroupRoleColumnSort?: ColumnSort;
    accessGroupRoleFilters: TableFilters;
    groupNameIsUnique: boolean;
    accessGroupUpdated: boolean;
    isSavingAccessGroup: boolean;
    accessGroupDocumentNames: DocumentNameDB[];
    allAccessGroupDocumentGroups: ClientDocumentGroup[];
    isFetchingEntities: boolean;
    isFetchingDocuments: boolean;
    isFetchingDocumentGroups: boolean;
    deleteConfirmationDialogOpen: boolean;
    deletingAccessGroup: boolean;
}
